import { Tag } from "@blueprintjs/core"
import IScalarForm from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { PE_TEST_QUESTION_TYPE } from "../data/interfaces"
import MultiChoice from "./answers/Multichoice"
import Range from "./answers/Range"

const TestQuestionAnswerWidget = ( props: IScalarForm ): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<AnswerEnabled {...props} />}
        desabledForm={<AnswerDisabled {...props} />}
    />
}

export default TestQuestionAnswerWidget

const AnswerEnabled =  (props: IScalarForm) :JSX.Element => { 
    //console.log(props.filter )
    switch((props.filter || PE_TEST_QUESTION_TYPE.MULTI_CHOOSE).toUpperCase()) {
        case PE_TEST_QUESTION_TYPE.RANGE:
            return <Range {...props} />
        case PE_TEST_QUESTION_TYPE.MULTI_CHOOSE:
        default:
            return <MultiChoice {...props} />
    }
    
}

const AnswerDisabled =  (props: IScalarForm) :JSX.Element => {
    return <div>
        {
            Array.isArray(props.value) 
                ?
                props.value.map((a:any) => {
                    return <Tag key={a.id} minimal>
                        {
                            a.title
                        }
                    </Tag>
                })
                :
                <></>
        }
    </div>
}